"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _react = _interopRequireWildcard(require("react"));

var _Paper = _interopRequireDefault(require("../Paper"));

var _wallet = _interopRequireDefault(require("./wallet"));

var _manual = _interopRequireDefault(require("./manual"));

var _WalletOutline = _interopRequireDefault(require("@p24/icons/WalletOutline"));

var _CardOutline = _interopRequireDefault(require("@p24/icons/CardOutline"));

var _l10n = _interopRequireDefault(require("../../common/l10n"));

var _sourceList = _interopRequireDefault(require("./style/main/sourceList"));

var _sourceLabel = _interopRequireDefault(require("./style/main/sourceLabel"));

var _sourceItem = _interopRequireDefault(require("./style/main/sourceItem"));

var _sourceIcon = _interopRequireDefault(require("./style/main/sourceIcon"));

var _sourceComponents, _sourceSwitcherDestin;

var sourceComponents = (_sourceComponents = {}, (0, _defineProperty2["default"])(_sourceComponents, _constants.SOURCE_WALLET, _wallet["default"]), (0, _defineProperty2["default"])(_sourceComponents, _constants.SOURCE_MANUAL, _manual["default"]), _sourceComponents);
var sourceSwitcherDestination = (_sourceSwitcherDestin = {}, (0, _defineProperty2["default"])(_sourceSwitcherDestin, _constants.SOURCE_MANUAL, {
  name: 'DEBIT_SOURCE_WALLET',
  icon: _WalletOutline["default"]
}), (0, _defineProperty2["default"])(_sourceSwitcherDestin, _constants.SOURCE_WALLET, {
  name: 'DEBIT_SOURCE_CARD',
  icon: _CardOutline["default"]
}), _sourceSwitcherDestin);

var DebitSource = function DebitSource(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      paper = _ref.paper,
      sourceList = _ref.sourceList,
      switcherLabel = _ref.switcherLabel,
      attribute = _ref.attribute,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["value", "onChange", "disabled", "paper", "sourceList", "switcherLabel", "attribute", "theme"]);
  var source = (value === null || value === void 0 ? void 0 : value.source) || sourceList && sourceList[0];
  var SourceIcon = sourceSwitcherDestination[source].icon;
  var SourceComponent = sourceComponents[source];
  var onSourceClick = (0, _react.useCallback)(function () {
    if (!disabled && typeof onChange === 'function') {
      var _onChange;

      onChange((_onChange = {
        source: source === _constants.SOURCE_WALLET ? _constants.SOURCE_MANUAL : _constants.SOURCE_WALLET
      }, (0, _defineProperty2["default"])(_onChange, _constants.ATTR_CVV, source === _constants.SOURCE_WALLET ? null : undefined), (0, _defineProperty2["default"])(_onChange, _constants.ATTR_EXP, source === _constants.SOURCE_WALLET ? null : undefined), (0, _defineProperty2["default"])(_onChange, _constants.ATTR_NUMBER, source === _constants.SOURCE_WALLET ? null : undefined), (0, _defineProperty2["default"])(_onChange, _constants.ATTR_CARD_ID, source === _constants.SOURCE_WALLET ? undefined : null), (0, _defineProperty2["default"])(_onChange, _constants.ATTR_FIRST_NAME, undefined), (0, _defineProperty2["default"])(_onChange, _constants.ATTR_LAST_NAME, undefined), _onChange));
    }
  }, [source, disabled, onChange]);

  var content = _react["default"].createElement(SourceComponent, (0, _extends2["default"])({
    value: value,
    onChange: onChange,
    disabled: disabled,
    attribute: attribute,
    theme: theme
  }, rest));

  return _react["default"].createElement("div", null, (sourceList === null || sourceList === void 0 ? void 0 : sourceList.length) > 1 ? _react["default"].createElement(_sourceList["default"], {
    theme: theme
  }, _react["default"].createElement(_sourceLabel["default"], {
    theme: theme,
    disabled: disabled
  }, _l10n["default"].t(switcherLabel)), _react["default"].createElement("div", {
    onClick: onSourceClick,
    "data-qa-node": "".concat(attribute, "Source"),
    "data-qa-value": source
  }, _react["default"].createElement(_sourceItem["default"], {
    theme: theme,
    disabled: disabled
  }, _react["default"].createElement("div", null, _l10n["default"].t(sourceSwitcherDestination[source].name)), _react["default"].createElement(_sourceIcon["default"], {
    theme: theme,
    disabled: disabled
  }, _react["default"].createElement(SourceIcon, {
    fill: disabled ? undefined : theme.palette.elAccent
  }))))) : null, paper ? _react["default"].createElement(_Paper["default"], {
    interactive: !disabled
  }, content) : content);
};

DebitSource.propTypes = {
  sourceList: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  list: _propTypes["default"].array,
  value: _propTypes["default"].shape({
    source: _propTypes["default"].string,
    cardId: _propTypes["default"].string,
    number: _propTypes["default"].string,
    expire: _propTypes["default"].string,
    firstName: _propTypes["default"].string,
    lastName: _propTypes["default"].string,
    cvv: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  debit: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  error: _propTypes["default"].object,
  wallet: _propTypes["default"].object,
  manual: _propTypes["default"].object,
  switcherLabel: _propTypes["default"].string,
  cvvHint: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
  paper: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  attribute: _propTypes["default"].string,
  name: _propTypes["default"].string,

  /**
   * Show cardholder's name
   * */
  cardholder: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.tsSmall
     */
    sourceFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlSmall
     */
    sourceLineHeight: _propTypes["default"].string,

    /**
     * @default palette.twSemi
     */
    sourceFontWeight: _propTypes["default"].number,

    /**
     * @default palette.tAccent
     */
    sourceColor: _propTypes["default"].string,

    /**
     * @default 1
     */
    sourceAppearanceOpacity: _propTypes["default"].number,

    /**
     * @default palette.tLabel
     */
    sourceLabelColor: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    hintColor: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    hintFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    hintLineHeight: _propTypes["default"].string,

    /**
     * @default palette.tAccentDark
     */
    hoverSourceColor: _propTypes["default"].string,

    /**
     * @default palette.tDisabled
     */
    disabledColor: _propTypes["default"].string,

    /**
     * @default 0.15
     */
    disabledSourceAppearanceOpacity: _propTypes["default"].number
  })
};
DebitSource.defaultProps = {
  debit: true,
  list: [],
  sourceList: [_constants.SOURCE_MANUAL, _constants.SOURCE_WALLET],
  switcherLabel: 'DEBIT_SOURCE_LABEL_CARD',
  cvvHint: true,
  paper: false,
  cardholder: false
};
var _default = DebitSource;
exports["default"] = _default;